/**
 * Created by josh on 17/08/11.
 * 路由元信息 meta 字段
 * path: string;
 * component?: Component;
 * name?: string; // for named routes (命名路由)
 * components?: { [name: string]: Component }; // for named views (命名视图组件)
 * redirect?: string | Location | Function; //路由重定向
 * alias?: string | Array<string>; 别名
 * children?: Array<RouteConfig>; // for nested routes
 * beforeEnter?: (route: Route, redirect: Function, next: Function) => void; //路由钩子
 * meta?: any; //参数
 */
import {
  API,
  SOURCE
} from '@lib/config';
import main from './main.js';
import attestation from './attestation.js';
// 路由入口
const mainRouter = () =>
  import ('../components/main.vue');
// 二级路由入口
const subRouter = () =>
  import ('../components/subRouter.vue');
// 注册
const enroll = () =>
  import ('../views/login/enroll.vue');
// 注册结果
const registResult = () =>
  import ('../views/login/registResult.vue');
// 修改密码
const retrievePassword = () =>
  import ('../views/login/retrievePassword.vue');
// 引导页面
// const guide = () =>
//   import ('../views/guide/guide.vue');

// fetch 配置环境
let option = {
  mode: 'cors',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  },
  method: 'GET'
};

export default [{
    path: '/main',
    component: mainRouter,
    children: main,
    beforeEnter: async (to, from, next) => {
      // console.log('进入main组件');
      // 获取 定制信息
      await fetch(`${API}/rest/v1/company/configuration/${SOURCE}`, option).then(response => response.json()).then((responseData) => {
        if (responseData.data) {
          window.sessionStorage.setItem('customizeInfo', JSON.stringify(responseData.data));
        } else {
          // console.log('定制---请求没有数据');
          window.sessionStorage.clear();
        }
      }, (response) => {
        // console.log('定制---请求失败');
        window.sessionStorage.clear();
      });

      fetch(`${API}/rest/v1/login/check?source=${SOURCE}&t=${Date.now()}`, option).then(response => response.json()).then(responseData => {
        // console.log('main-session接口请求成功');
        if (!responseData.data.isLogined) {
          // console.log('main-session失效跳转');
          if (SOURCE == 'esign') {
            next({ path: '/login' });
          } else {
            next(false);
            window.location.href = responseData.data.redirectUrl;
          }
          return false;
        }
        // console.log('main-session验证成功');
        next();
      }, (response) => {
        // console.log('main-session请求失败');
        next(false);
      });
    }
  },
  {
    path: '/attestation',
    component: subRouter,
    children: attestation,
    beforeEnter: (to, from, next) => {
      // console.log('进入attestation组件');
      fetch(`${API}/rest/v1/login/check?source=${SOURCE}&t=${Date.now()}`, option).then(response => response.json()).then(responseData => {
        // console.log('attestation-session接口请求成功');
        if (!responseData.data.isLogined) {
          // console.log('attestation-session失效跳转');
          if (SOURCE == 'esign') {
            next({ path: '/login' });
          } else {
            next(false);
            window.location.href = responseData.data.redirectUrl;
          }
          return false;
        }
        // console.log('attestation-session验证成功');
        next();
      }, (response) => {
        // console.log('attestation-session请求失败');
        next(false);
      });
    }
  },
  // 找回密码 retrievePassword
  {
    path: '/retrievePassword',
    name: 'RetrievePassword',
    component: retrievePassword
  },
  // 企业和个人注册 enroll
  {
    path: '/enroll',
    component: subRouter,
    children: [{
        path: '/',
        name: 'Enroll',
        component: enroll
      },
      // 注册结果 registResult
      {
        path: 'registResult',
        name: 'RegistResult',
        component: registResult
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/pages/admin/router/menu.js